// Centralized configuration for Features section (tokens, labels, mappings)

export const SPECIAL_TOKENS = {
  NA: 'N/A',
  TBD: 'TBD'
} as const;

export type SpecialToken = (typeof SPECIAL_TOKENS)[keyof typeof SPECIAL_TOKENS];

export const DISPLAY_LABELS = {
  noFeatures: 'No features available',
  loading: 'Loading features...'
} as const;

// Risk mappings used to normalize various risk inputs
export const RISK_ICON_KEYWORDS = {
  high: ['high', 'red'],
  moderate: ['moderate', 'yellow'],
  low: ['low', 'green']
} as const;

// Utility helpers shared by container/presentational code
export function isSpecialToken(value: string | undefined): boolean {
  if (!value) return false;
  const upper = String(value).trim().toUpperCase();
  return upper === SPECIAL_TOKENS.NA || upper === SPECIAL_TOKENS.TBD;
}

export function coalescePhaseLabel(value: any): string {
  const s = String(value ?? '').trim();
  return s !== '' ? s : SPECIAL_TOKENS.NA;
}
